<template>
  <div class="mdm_group_page">
    <h3 class="title-page">{{ $t("columns") }}</h3>
    <div>
      <div class="admin_container">
        <div class="mdm_main">
          <table-with-filter
            :isFilterable="false"
            :height="$vuetify.breakpoint.height - 160"
            handler-value="name"
            fixed-header
            :headers="headers"
            :items="items"
          >
            <!--            <template #filter.name>-->
            <!--              <div class="pa-1">-->
            <!--                <custom-input-text-->
            <!--                  v-model="filter.name"-->
            <!--                  class="user_input no-margin"-->
            <!--                  @input="filterColumn"-->
            <!--                  clearable-->
            <!--                />-->
            <!--              </div>-->
            <!--            </template>-->

            <template #item.action="{ item }">
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="new_style"
                    @click="edit('create', item.slug)"
                  >
                    <vue-icon icon="newPlusIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("create") }}</span>
              </v-tooltip>
            </template>
            <template #expandBtn="{ item, openHandler }">
              <triangle-btn @click="openHandler(item)" :active="item.show" />
            </template>
            <template #child.action="{ child, item }">
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="edit('edit', item.slug, child)"
                  >
                    <vue-icon icon="newPencilIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
              <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="deleteItem(child)"
                  >
                    <vue-icon icon="newTrashIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("delete") }}</span>
              </v-tooltip>
            </template>
          </table-with-filter>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="528" class="user_modal_dialog">
      <v-card>
        <validation-observer v-slot="{ handleSubmit }" ref="form">
          <v-form @submit.prevent="handleSubmit(save)">
            <v-card-title class="">
              <span class="headline title_modal_user">{{ formTitle }}</span>
              <v-icon @click="dialog = false" class="info_modal_close"
                >mdi-close</v-icon
              >
            </v-card-title>
            <v-card-text class="main_modal">
              <custom-input-text
                :label="$t('columnLabel') + '*'"
                rules="required"
                class="user_input no-margin"
                v-model="formData.columnLabel"
                :placeholder="$t('columnLabel')"
              ></custom-input-text>
              <custom-input-text
                :label="$t('columnValue') + '*'"
                rules="required"
                v-model="formData.columnName"
                class="user_input no-margin"
                :placeholder="$t('columnName')"
              ></custom-input-text>
              <custom-input-text
                :label="$t('position')"
                type="number"
                class="user_input no-margin"
                v-model="formData.position"
              >
              </custom-input-text>
              <custom-input-text
                :label="$t('minWidth') + '*'"
                rules="required"
                v-model="formData.minWidth"
                class="user_input no-margin"
                :placeholder="$t('minWidth')"
              ></custom-input-text>
              <div class="d-flex pb-2 ma-n2 flex-wrap">
                <div class="pa-2">
                  <v-switch
                    class="mt-1"
                    hide-details
                    dense
                    :label="$t('visible')"
                    v-model="formData.visible"
                  ></v-switch>
                </div>
                <div class="pa-2">
                  <v-switch
                    class="mt-1"
                    hide-details
                    dense
                    :label="$t('sortable')"
                    v-model="formData.sortable"
                  ></v-switch>
                </div>
                <div class="pa-2">
                  <v-switch
                    class="mt-1"
                    hide-details
                    dense
                    :label="$t('enable')"
                    v-model="formData.enable"
                  ></v-switch>
                </div>
              </div>

              <span class="text--accent-1 blue-dark--text">{{
                $t("roles")
              }}</span>
              <div class="d-flex ma-n2 flex-wrap">
                <div
                  class="pa-2"
                  :key="`rile-${role.id}`"
                  v-for="role in roles"
                >
                  <v-checkbox
                    class="mt-0"
                    hide-details
                    :label="role.name"
                    v-model="formData.roleIds"
                    :value="role.id"
                  ></v-checkbox>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="footer_modal_user">
              <div class="row">
                <div
                  class="d-flex flex-wrap justify-space-around button_modal_add mr-3 mt-3"
                >
                  <v-btn color="primary" dark type="submit"
                    >{{ $t("save") }}
                  </v-btn>
                </div>
              </div>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-card>
    </v-dialog>
    <warning-dialog
      ref="deleteDialog"
      @apply="deleteItemHandler"
      v-model="confirmDialog"
    ></warning-dialog>
  </div>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog";
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import { TABLES } from "@/utils/constants";
import { trueSet } from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";

export default {
  name: "attribute-reference",
  data() {
    return {
      dialog: false,
      confirmDialog: false,
      items: Object.entries(TABLES).map(([key, obj]) => {
        return {
          name: key,
          children: [],
          show: true,
          slug: obj.slug,
        };
      }),
      roles: [],
      formData: {
        columnLabel: "",
        columnName: "",
        minWidth: "auto",
        position: null,
        roleIds: [],
        sortable: true,
        visible: true,
      },
      filter: {
        name: null,
      },
    };
  },
  computed: {
    formTitle() {
      return this.formData.id ? this.$t("editGroup") : this.$t("create");
    },
    headers() {
      return [
        {
          text: this.$t("tableName"),
          value: "name",
        },
        {
          text: this.$t("columnLabel"),
          value: "columnLabel",
        },
        {
          text: this.$t("columnName"),
          value: "columnName",
        },
        {
          text: this.$t("position"),
          value: "position",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
  },
  components: {
    TableWithFilter,
    TriangleBtn,
    WarningDialog,
  },
  watch: {
    dialog(val) {
      if (!val) this.clearForm();
    },
  },

  methods: {
    // filterColumn: debounce(async function () {
    //   this.showLoading();
    //   await this.getItems();
    //   this.clearLoading();
    // }, 300),
    clearForm() {
      const { form } = this.$refs;
      this.formData = {
        columnLabel: "",
        columnName: "",
        minWidth: "auto",
        position: null,
        roleIds: [],
        sortable: true,
        visible: true,
      };
      if (form) form.reset();
    },
    async deleteItemHandler() {
      this.showLoading();
      const { id } = this.formData;
      try {
        await this.$http.delete(`column-settings/delete?id=${id}`);
        this.clearForm();
        await this.getItems();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    deleteItem(item) {
      this.confirmDialog = true;
      this.formData = { ...item };
    },
    edit(type, table, item) {
      if (type === "create") {
        this.formData.table = table;
      } else if (type === "edit") {
        const {
          columnLabel,
          columnName,
          minWidth,
          position,
          roleIds,
          sortable,
          visible,
          id,
          enable,
        } = item;
        this.formData = {
          id,
          columnLabel,
          columnName,
          minWidth,
          position,
          roleIds,
          sortable,
          visible,
          enable,
          table,
        };
      }
      this.dialog = true;
    },
    async save() {
      this.showLoading();
      try {
        await this.$http.post("column-settings/save", this.formData);
        await this.getItems();
        this.dialog = false;
        this.clearForm();
        this.setSuccess({
          title: this.$t("successfullySaved"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getItems(setQuery) {
      if (setQuery) {
        await this.$router.push({
          query: { page: this.configuration.page.toString() },
        });
      }
      try {
        const {
          data: { data: OrderColumns },
        } = await this.$http.get("column-settings/list", {
          params: { table: TABLES["Order"].slug, ...this.filter },
        });
        const {
          data: { data: ContractColumns },
        } = await this.$http.get("column-settings/list", {
          params: { table: TABLES["Contract"].slug, ...this.filter },
        });
        this.items[TABLES.Order.index].children = OrderColumns.map((item) => {
          item.custom = trueSet(item.custom);
          item.visible = trueSet(item.visible);
          item.sortable = trueSet(item.sortable);
          item.enable = trueSet(item.enable);
          return item;
        });
        this.items[TABLES.Contract.index].children = ContractColumns;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  async created() {
    this.showLoading();
    try {
      const { page } = this.$route.query;
      if (page) {
        this.configuration.page = +page;
      }
      await this.getItems();
      const { data: roles } = await this.$store.dispatch("getRoles");
      this.roles = roles;
    } catch (e) {
      this.setResponseError({ error: e });
    } finally {
      this.clearLoading();
    }
  },
};
</script>

<style scoped></style>
